import axiosApiClient from "../axios";

const PATH = '/api/camera';

const zonesPath = (cameraId) => `${PATH}/${cameraId}/restricted-zones`;

export const getRestrictedZones = async (cameraId) => {
    const response = await axiosApiClient.get(zonesPath(cameraId));
    return response.data;
};

/** Replaces the camera's whole zone set. Zones without a zoneId are created. */
export const saveRestrictedZones = async (cameraId, zones) => {
    try {
        const response = await axiosApiClient.put(zonesPath(cameraId), zones, {});
        return response.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Save restricted areas failed');
    }
};

export const deleteRestrictedZone = async (cameraId, zoneId) => {
    try {
        return await axiosApiClient.delete(`${zonesPath(cameraId)}/${zoneId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Delete restricted area failed');
    }
};

export const getRestrictedZoneCountsByBranch = async (branchId) => {
    const response = await axiosApiClient.get(`/api/restricted-zones/counts/branch/${branchId}`);
    return response.data;
};

/**
 * One still frame to draw zones on, as an object URL.
 *
 * The backend proxies this from the detector, which may have to open an RTSP
 * session and wait for a clean frame — slower than a normal API call, hence the
 * raised timeout. Callers must revokeObjectURL when they are done with it.
 */
export const getCameraSnapshotUrl = async (cameraId) => {
    try {
        const response = await axiosApiClient.get(`${PATH}/${cameraId}/snapshot`, {
            responseType: 'blob',
            timeout: 45000,
        });
        return URL.createObjectURL(response.data);
    } catch (err) {
        throw new Error(err.response?.data?.message
            || 'Could not capture a frame. Check that the camera is online.');
    }
};
